import { BannerId } from '../../../typings/banners';

export const DUPLICATE_INTERNAL_BANNER = 'DUPLICATE_INTERNAL_BANNER';
export type DUPLICATE_INTERNAL_BANNER = typeof DUPLICATE_INTERNAL_BANNER;
export interface DuplicateInternalBanner {
    type: DUPLICATE_INTERNAL_BANNER;
    bannerId: BannerId;
    newBannerId: BannerId;
}

export function duplicateInternalBannerAction(bannerId: BannerId, newBannerId: BannerId): DuplicateInternalBanner {
    return {
        type: DUPLICATE_INTERNAL_BANNER,
        bannerId,
        newBannerId
    };
}
